import type { ContentObject } from 'models';
import { useMutation } from 'query';
import { useUpdateLike } from '../../hooks';
import { likeObject } from '../../services';

export const useLikeObjectMutation = () => {
  const updateCache = useUpdateLike({ action: 'like' });

  return useMutation<unknown, { contentObject: ContentObject }>({
    mutationFn: async ({ contentObject }) => likeObject({ routeParams: { id: contentObject.id } }),
    onSuccess(_, params) {
      updateCache(params);
    },
  });
};
